export default __webpack_public_path__ + "a55ff70d7e88d2c0231548753e7ad7f6.svg";